import { Navigate, useLocation } from 'react-router-dom';

import AssistantPane from './panes/assistant/AssistantPane';
import { PATHS } from './paths';
import { getAssistantSheetHandoff, withAssistantSheet } from './providers/assistantSheetHistory';
import { useSidePanel } from './providers/SidePanelProvider';

/**
 * `/assistant` is the pane's home only where the pane is a route — between
 * `md` and `xl`. At `xl+` the side column in `HomeScene` already mounts it
 * (open by default), and below `md` the sheet does; rendering the pane here
 * too would mount a *second* `AssistantPane` and its live WebSocket, which the
 * server evicts into a terminal `superseded` state. Those sites redirect to the
 * dashboard instead — the sheet's redirect carrying the history state that
 * opens it, so a bookmarked or shared link still lands in the assistant. An
 * entry the route took over from an open sheet holds that sheet's origin, and
 * the redirect hands it back so closing pops the way it would have.
 *
 * `replace`, so Back from the landing page does not re-enter this gate.
 * All three sites read the provider's one `assistantMountSite`, which is what
 * keeps them mutually exclusive within a render.
 */
const AssistantRouteGate = () => {
  const { assistantMountSite } = useSidePanel();
  const location = useLocation();
  if (assistantMountSite === 'route') {
    return <AssistantPane />;
  }
  if (assistantMountSite === 'sheet') {
    const origin = getAssistantSheetHandoff(location.state) ?? 'replaced';
    return <Navigate to={PATHS.DASHBOARD} replace state={withAssistantSheet(null, origin)} />;
  }
  return <Navigate to={PATHS.DASHBOARD} replace />;
};

export default AssistantRouteGate;
